import React, { Component } from 'react';
import { connect } from 'react-redux';
import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';

import Relationship from './Relationship';

import {
  relationshipSelector,
} from '../../../reducers/relationships';
import {
  elementsSelector,
} from '../../../reducers/elements';
import {
  relationshipTypesSelector,
} from '../../../reducers/relationshipTypes';

const RelationshipContainerSelector = immutableCreatorSelector(
  [
    relationshipSelector,
    relationshipTypesSelector,
    elementsSelector,
  ],
  (
    relationship,
    relationshipTypes,
    elements,
  ) => ({
    relationship,
    relationshipTypes,
    elements,
  }),
);

@connect(RelationshipContainerSelector)
export default
class RelationshipContainer extends Component {
  render() {
    return <Relationship {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/RightColumn/Relationship/RelationshipContainer.js